import { ReactiveVar } from "@apollo/client";
import { GetSportEquipmentInput, SportEquipmentTransferStatus } from "graphql/graphQlApiHooks";
import { SportEquipmentListFilters, sportEquipmentListFiltersVars } from "./sportEquipmentListFilters";
import { SportEquipmentTab, sportEquipmentTabActiveVars, SportEquipmentTabIdsEnum } from "./sportEquipmentTabActive";
import { SportEquipmentListPagination, sportEquipmentListPaginationVars } from "./sportEquipmentListPagination";
import { SportEquipmentListSortOrder, sportEquipmentListSortOrderVar } from "./sportEquipmentListSortOrder";
import { SportObjectsVars, sportObjectsVars } from "../sport-objects/sportObjects";
import { buildOrderBy } from "./buildOrderBy";


export const useGetSportEquipmentInputVars = () => (
  createGetSportEquipmentInputVars(sportEquipmentTabActiveVars, sportEquipmentListFiltersVars, sportEquipmentListPaginationVars, sportEquipmentListSortOrderVar, sportObjectsVars)
);

const createGetSportEquipmentInputVars = (
  sportEquipmentTabActiveVars: ReactiveVar<SportEquipmentTab>,
  sportEquipmentListFiltersVars: ReactiveVar<SportEquipmentListFilters>,
  sportEquipmentListPaginationVars: ReactiveVar<SportEquipmentListPagination>,
  sportEquipmentListSortOrderVar: ReactiveVar<SportEquipmentListSortOrder>,
  sportObjectsVars: ReactiveVar<SportObjectsVars>
) => {

  const tabActive = sportEquipmentTabActiveVars();
  const sportEquipmentsFilters = sportEquipmentListFiltersVars();
  const pagination = sportEquipmentListPaginationVars();
  const sortOrderModel = sportEquipmentListSortOrderVar();
  const sportObjects = sportObjectsVars();

  const filters = () => {
    const {commissioningDate, ...filters} = sportEquipmentsFilters
    const filtered = Object.fromEntries(
      Object.entries(filters).filter(([_, value]) => value !== null && value !== undefined)
    );
    return {
      ...filtered,
      ...(commissioningDate && {
        commissioningDateFrom: commissioningDate?.startDate?.toISOString(),
        commissioningDateTo: commissioningDate?.endDate?.toISOString(),
      } )
    }
  }

  const getInput = (): GetSportEquipmentInput => {
    const orderBy = buildOrderBy(sortOrderModel);

    return {
      sportObjectIds: [...sportObjects.selectedSportObjectIds],

      ...(filters && { ...filters() }),

      // Для таба "Оборудование на объектах" исключаем оборудование на складе
      ...(tabActive?.id === SportEquipmentTabIdsEnum.ALL_EQUIPMENTS && { archived: false }),
      // Для таба "Склад" показываем только оборудование на складе
      ...(tabActive?.id === SportEquipmentTabIdsEnum.IS_ARCHIVED && { archived: true }),
      // Для таба "Списанное оборудование" своя логика с isWroteOff
      ...(tabActive?.id === SportEquipmentTabIdsEnum.IS_WROTE_OFF && { isWroteOff: true, transferStatus: SportEquipmentTransferStatus.TransferredToSubordinate }),

      ...(orderBy && { order: orderBy }),

      ...(pagination && {
        skip: pagination?.page * pagination?.pageSize,
        take: pagination?.pageSize
      }),

    };
  };


  return {
    getInput
  };
};

